<template>
  <div>
    <table v-if="tableData.length">
      <colgroup>
        <col style="width: 100px" />
        <col style="width: auto" class="media-none" />
        <col style="width: auto; min-width: 100px" />
        <col style="width: auto" class="media-none" />
        <col style="width: auto" class="media-none" />
        <col style="width: 150px; min-width: 150px" />
      </colgroup>
      <thead>
        <tr>
          <th>海报</th>
          <th class="media-none">小程序路径</th>
          <th>城市</th>
          <th class="media-none">已分享人</th>
          <th class="media-none">已扫码人次</th>
          <th>操作</th>
        </tr>
      </thead>
      <tr v-for="item in tableData" :key="item.id">
        <td>
          <div class="line">
            <div class="cover" @click="onPicClick(item.posterInfo.url)">
              <img
                class="pic"
                :src="item.posterInfo.url + '?imageView2/2/w/140'"
                alt="封面"
              />
            </div>
          </div>
        </td>
        <td class="media-none">
          <div class="line">
            <div class="path">{{ connectPath(item.posterInfo) }}</div>
          </div>
        </td>
        <td>
          <div class="line">{{ item.cityName }}</div>
        </td>
        <td class="media-none">
          <div class="line">{{ item.shareNumber }}</div>
        </td>
        <td class="media-none">
          <div class="line">{{ item.scanNumber }}</div>
        </td>
        <td>
          <div class="line-right">
            <van-button type="info" size="small" @click="createPoster(item)"
              ><nobr>生成我的海报</nobr></van-button
            >
          </div>
        </td>
      </tr>
    </table>
    <canvas id="myCanvas" style="display: none"></canvas>
    <div class="all-loading" v-if="isLoading">
      <van-loading size="24px">加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import uploadbase64Img from "@/utils/uploadImg";
import { ImagePreview } from "vant";

export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    // 拼接小程序路径
    connectPath({ page, scene }) {
      return `${page}?scene=${scene}`;
    },
    // 分享海报
    async createPoster(item) {
      this.isLoading = true;
      console.log("生成海报", item);
      try {
        // 生成小程序码，绘制海报
        // const qrcodeData = "https://imgs.izhikang.com/izkapp/admin/220d69cb-546b-43c4-bbe7-82b48dd85126"
        const qrcodeData = await this.createQrcode(
          item.posterInfo,
          this.formData.workCode,
          item.id
        );
        const posterData = await this.drawPoster(item.posterInfo, qrcodeData);
        // 上传图片
        const upload = new uploadbase64Img();
        const picUrl = await upload.upload(posterData.dataUrl);
        console.log("上传图片url", picUrl);
        // 分享海报
        const data = {
          bizId: item.bizId,
          workCode: this.formData.workCode,
          cityCode: item.cityCode,
          url: picUrl,
        };
        await this.$api.poster.sharePoster(data);
        this.$notify({ type: "success", message: "分享海报成功" });
      } catch (error) {
        if (typeof error === "string") {
          this.$notify(error);
        } else {
          this.$notify("生成海报失败了");
        }
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    // 生成小程序码
    createQrcode({ appId, page, scene }, workCode, id) {
      return new Promise((resolve, reject) => {
        // scene小程序参数 workCode工号  id海报id
        const data = { appId, page, scene: `${scene}_${workCode}_${id}` };
        this.$api.poster
          .getMiniProgramCode(data)
          .then((res) => {
            console.log("生成小程序码", res);
            if (res.data.bufferStr) {
              resolve(`data:image/png;base64,${res.data.bufferStr}`);
            } else {
              reject("生成小程序码失败");
            }
          })
          .catch(() => {
            reject("生成小程序码失败");
          });
      });
    },
    // 绘制海报, 将海报+二维码绘制到一起
    drawPoster(posterInfo, miniProgramCode) {
      return new Promise((resolve, reject) => {
        // 创建canvas
        const canvas = document.getElementById("myCanvas");
        if (!canvas.getContext) {
          this.$notify("不支持canvas,生成海报失败");
          reject("不支持canvas,生成海报失败");
          return;
        }
        const ctx = canvas.getContext("2d");
        // 绘制背景图
        const img = new Image();
        img.crossOrigin = "anonymous";
        const src = posterInfo.url;
        // 替换图片域名，解决跨域
        const newSrc = src.replace(
          "izhikang-img-1256037416.cos.ap-beijing.myqcloud.com",
          "imgs.izhikang.com"
        );
        img.src = newSrc;
        img.onerror = () => reject("海报图片加载失败");
        img.onload = () => {
          // 设置canvas大小
          canvas.width = img.width;
          canvas.height = img.height;
          // 绘制背景图
          ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            0,
            0,
            img.width,
            img.height
          );
          // 在原来图片的基础上绘制小程序码
          const codeImg = new Image();
          codeImg.src = miniProgramCode;
          codeImg.onerror = () => reject("小程序码图片加载失败");
          codeImg.onload = () => {
            // 绘制小程序码
            ctx.drawImage(
              codeImg,
              0,
              0,
              codeImg.width,
              codeImg.height,
              posterInfo.x,
              posterInfo.y,
              posterInfo.width,
              posterInfo.height
            );
            // 保存图片
            const dataUrl = canvas.toDataURL("image/png", 1.0);
            resolve({
              dataUrl,
              width: img.width,
              height: img.height,
            });
          };
        };
      });
    },
    // 点击海报图片
    onPicClick(src) {
      ImagePreview({ images: [src], showIndex: false, closeable: true });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
// 媒体查询超出手机屏幕宽度隐藏元素
@media screen and (max-width: 720px) {
  .media-none {
    display: none;
  }
}

table {
  width: 95%;
  margin: auto;
  margin-top: 5px;
  border-collapse: collapse;
  thead {
    tr {
      height: 50px;
      line-height: 50px;
    }
  }
  tr {
    border-bottom: 1px solid #ddd;
  }
  td {
    height: 110px;
    position: relative;
    text-align: center;
  }
  .line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .line-right {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 20px;
  }
  .path {
    text-align: left;
    font-size: 12px;
    line-height: 20px;
    height: 60px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}

// 封面样式
.cover {
  padding: 5px;
  margin-right: 10px;
  width: 70px;
  height: 100px;
  .pic {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: cover;
  }
}

.all-loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
